export default __webpack_public_path__ + "resources/icons/n0-808a.png";